window.setCookie = (name, value, days = 365) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${name}=${(value || '')}${expires}; path=/`;
}


window.getCookie = (name) => {
  const nameEQ         = `${name}=`;
  const arrayOfCookies = document.cookie.split(';');

  for(let rawCookie of arrayOfCookies) {
    let cookie = rawCookie;
    while (cookie.charAt(0) == ' ') cookie = cookie.substring(1, cookie.length);
    if (cookie.indexOf(nameEQ) == 0) return  cookie.substring(nameEQ.length, cookie.length);
  }

  return null;
}


window.removeCookie = (name) => {
  document.cookie = `${name}=; Max-Age=-99999999;`;
}


window.checkIfCookiesAccepted = () => {
  if (!getCookie('acceptedCookie')) {
    const cookies = document.getElementById('cookies');
    if (!!cookies) {
      cookies.classList.remove('hidden');
      cookies.classList.remove('accepted');

      const acceptCookie = cookies.getElementsByClassName('btn--accept-cookies')[0];
      if (!!acceptCookie) {
        acceptCookie.addEventListener('click', () => {
          cookies.classList.add('accepted');
          setCookie('acceptedCookie', 'true');

          setTimeout(() => {
            cookies.classList.add('hidden');
          }, 300);
        });
      }
    }
  }
}
